"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ChannelNames;
(function (ChannelNames) {
    ChannelNames["ENTITY_MANAGEMENT"] = "EntityManagement";
    ChannelNames["SUBSYS_VOICE"] = "SubsysVoice";
    ChannelNames["SUBSYS_CHAT"] = "SubsysChat";
})(ChannelNames || (ChannelNames = {}));
exports.default = ChannelNames;
//# sourceMappingURL=ChannelNames.js.map